export default __webpack_public_path__ + "static/media/blog1.9da5cbe6.png";